export default "__VITE_ASSET__90c9be1c__"